import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { blueGrey } from '@mui/material/colors';

const tableCell = {
	color: blueGrey[50],
	paddingLeft: 3,
	border: 'none',
	'& .MuiCheckbox-root.Mui-checked': {
		color: blueGrey[50],
	},
	'& .MuiTableSortLabel-root.MuiSvdIcon-root': {
		color: blueGrey[50],
	},
	'& .MuiTableSortLabel-icon ': {
		opacity: 0.5,
		color: 'blueGrey[50]',
	},
	'& .MuiButtonBase-root.MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon':
		{
			opacity: 1,
			color: blueGrey[50],
		},
};

export default function ScreenersTableHeader({
	cells,
	handleSorting,
	screenersTableSettings,
}) {
	return (
		<TableHead
			sx={{
				position: 'sticky',
				top: 0,
				zIndex: 100,
				backgroundColor: blueGrey[800],
				color: blueGrey[50],
				marginBottom: 16,
				border: 'none',
			}}
		>
			<TableRow>
				<TableCell
					align='left'
					sx={tableCell}
				></TableCell>
				{cells.map((cell) => (
					<TableCell
						key={cell.id}
						align={cell.align}
						padding={cell.disablePadding ? 'none' : 'normal'}
						sortDirection={
							screenersTableSettings.sortBy === cell.id
								? screenersTableSettings.sortOrder
								: false
						}
						sx={tableCell}
						style={{ width: `calc(100% / ${cells.length})` }}
					>
						{cell.label}
						{cell.sortable && (
							<TableSortLabel
								active={screenersTableSettings.sortBy === cell.id}
								direction={
									screenersTableSettings.sortBy === cell.id
										? screenersTableSettings.sortOrder
										: 'asc'
								}
								onClick={() => handleSorting(cell.id)}
								sx={tableCell}
							/>
						)}
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

ScreenersTableHeader.propTypes = {
	cells: PropTypes.array.isRequired,
	handleSorting: PropTypes.func.isRequired,
	screenersTableSettings: PropTypes.object.isRequired,
};
